var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_setup.loading && _setup.group
    ? _c("div", { attrs: { id: "value-frames" } }, [
        _c("div", { staticClass: "row mb-5" }, [
          _c(
            "div",
            { staticClass: "col-lg-7" },
            [
              _c("h4", { staticClass: "mb-3" }, [
                _vm._v("Choose your item's size:"),
              ]),
              _c(_setup.StandardSizeSelector, {
                model: {
                  value: _setup.itemSize,
                  callback: function ($$v) {
                    _setup.itemSize = $$v
                  },
                  expression: "itemSize",
                },
              }),
              _c("h4", { staticClass: "mb-3 mt-5" }, [
                _vm._v("Choose your frame's style:"),
              ]),
              _setup.length
                ? _c(_setup.MouldingOptions, {
                    attrs: { lengths: _setup.group.lengths },
                    model: {
                      value: _setup.length,
                      callback: function ($$v) {
                        _setup.length = $$v
                      },
                      expression: "length",
                    },
                  })
                : _vm._e(),
              _c("h4", { staticClass: "mb-3 mt-5" }, [
                _vm._v("Choose your mount colour (optional):"),
              ]),
              _c(_setup.MountboardColours, {
                model: {
                  value: _setup.selectedBoard,
                  callback: function ($$v) {
                    _setup.selectedBoard = $$v
                  },
                  expression: "selectedBoard",
                },
              }),
              _c("h4", { staticClass: "mb-3 mt-5" }, [
                _vm._v("Choose your picture frame's design:"),
              ]),
              _c(_setup.FrameDesignSelector, {
                attrs: {
                  "group-id": _setup.group.id,
                  "item-size": _setup.artworkSize,
                  "length-sku": _setup.length.sku,
                  mount: _setup.selectedBoard,
                },
                model: {
                  value: _setup.frameSize,
                  callback: function ($$v) {
                    _setup.frameSize = $$v
                  },
                  expression: "frameSize",
                },
              }),
            ],
            1
          ),
          _c("div", { staticClass: "col" }, [
            _c(
              "div",
              { staticClass: "sticky-top pt-3" },
              [
                _c(_setup.FrameVisualisation, {
                  attrs: {
                    sku: _setup.length.sku,
                    "chevron-images": _setup.length.chevronImages,
                    "artwork-dimensions": _setup.artworkSize,
                    "rebate-dimensions": _setup.rebateSize,
                    backing: true,
                    mount: _setup.mountOption,
                  },
                }),
                _c("p", { staticClass: "text-center" }, [
                  _vm._v(_vm._s(_setup.frameDescription)),
                ]),
                _c("p", { staticClass: "lead text-center" }, [
                  _vm._v("Price: "),
                  _c("strong", [_vm._v("£" + _vm._s(_setup.price))]),
                  _vm._v(" each (" + _vm._s(_setup.vatMode) + " VAT)"),
                ]),
              ],
              1
            ),
          ]),
        ]),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-lg-7" },
            [
              _c("h4", { staticClass: "mb-3" }, [
                _vm._v("Choose your glazing options:"),
              ]),
              _c(_setup.GlazingOptions, {
                attrs: {
                  "frame-size": _setup.frameSize,
                  "group-id": _setup.props.groupId,
                },
                model: {
                  value: _setup.glazing,
                  callback: function ($$v) {
                    _setup.glazing = $$v
                  },
                  expression: "glazing",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col mb-3" },
            [
              _c("h4", { staticClass: "mb-3" }, [
                _vm._v("Choose you hangings/fixings:"),
              ]),
              _c(_setup.FixingOptions, {
                attrs: {
                  "rebate-size": _setup.rebateSize,
                  "group-id": _setup.props.groupId,
                },
                model: {
                  value: _setup.fixings,
                  callback: function ($$v) {
                    _setup.fixings = $$v
                  },
                  expression: "fixings",
                },
              }),
              _c("h4", { staticClass: "mb-3 mt-5" }, [
                _vm._v("Order Specification"),
              ]),
              _c(_setup.FrameSpecification, {
                attrs: {
                  "item-size": _setup.itemSize,
                  "frame-size": _setup.frameSize,
                  length: _setup.length,
                  "has-mount": _setup.hasMount,
                  mount: _setup.selectedBoard,
                  glazing: _setup.glazing,
                  fixings: _setup.fixings,
                  "unit-price": _setup.discountedPrice,
                  validation: _setup.validation,
                },
              }),
              _c(
                _setup.BFormGroup,
                {
                  attrs: {
                    label: "Quantity:",
                    "label-cols-sm": "5",
                    "label-size": "lg",
                    "label-align-sm": "right",
                  },
                },
                [
                  _c(_setup.BFormInput, {
                    attrs: {
                      size: "lg",
                      type: "number",
                      number: "",
                      step: "1",
                      min: "1",
                    },
                    model: {
                      value: _setup.quantity,
                      callback: function ($$v) {
                        _setup.quantity = $$v
                      },
                      expression: "quantity",
                    },
                  }),
                ],
                1
              ),
              _c(
                _setup.BAlert,
                {
                  attrs: {
                    show:
                      (!_setup.stock.frame || !_setup.stock.mount) &&
                      !_setup.loadingStock,
                    variant: "danger",
                  },
                },
                [
                  !_setup.stock.frame
                    ? _c("p", { staticClass: "mb-0" }, [
                        _vm._v("There is not enough stock of the "),
                        _c("strong", [_vm._v("moulding")]),
                        _vm._v(" you have chosen to fulfil your order."),
                      ])
                    : _vm._e(),
                  !_setup.stock.mount
                    ? _c("p", { staticClass: "mb-0" }, [
                        _vm._v("There is not enough stock of the "),
                        _c("strong", [_vm._v("mountboard")]),
                        _vm._v(" you have chosen to fulfil your order."),
                      ])
                    : _vm._e(),
                ]
              ),
              _c(
                _setup.BAlert,
                {
                  attrs: { show: _setup.isCollectionOnly, variant: "warning" },
                },
                [
                  !_setup.deliveryValidation.frame.isValid
                    ? _c("p", { staticClass: "mb-0" }, [
                        _vm._v(
                          "Due to the size of the frame we are unable to delivery this item. However, you are welcome to collect from our workshop."
                        ),
                      ])
                    : !_setup.deliveryValidation.glazing.isValid
                    ? _c("p", { staticClass: "mb-0" }, [
                        _vm._v(
                          "Due to the size of the glass in the frame we are unable to delivery this item. However, you are welcome to collect from our workshop."
                        ),
                      ])
                    : _vm._e(),
                ]
              ),
              _c(
                "div",
                { staticClass: "text-right" },
                [
                  _c(
                    _setup.BOverlay,
                    {
                      staticClass: "d-inline-block",
                      attrs: {
                        show: _setup.isBuyButtonLoading,
                        rounded: "",
                        "spinner-small": "",
                      },
                    },
                    [
                      _c(
                        _setup.BButton,
                        {
                          attrs: {
                            size: "lg",
                            variant: _setup.isBuyButtonValid
                              ? "success"
                              : "danger",
                            disabled: _setup.isBuyButtonDisabled,
                          },
                          on: { click: _setup.onAddToCart },
                        },
                        [
                          _c("span", { staticClass: "material-icons mr-2" }, [
                            _vm._v("shopping_cart"),
                          ]),
                          _vm._v(
                            "Add to Cart (£" +
                              _vm._s(_setup.totalPrice) +
                              " " +
                              _vm._s(_setup.vatMode) +
                              " VAT)"
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _setup.discount > 0
                    ? _c("p", [
                        _c("em", [
                          _vm._v("(You save " + _vm._s(_setup.discount) + "%)"),
                        ]),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _c(
                _setup.BCard,
                { staticClass: "my-3" },
                [
                  _c("h4", { staticClass: "card-title" }, [
                    _vm._v("Volume Discounts"),
                  ]),
                  _c("p", { staticClass: "card-text" }, [
                    _vm._v("The more you buy, the more you save!"),
                  ]),
                  _c(_setup.DiscountsBreakdown, {
                    attrs: {
                      "sku-prefix": "UVF",
                      "item-type": "Frame",
                      price: _setup.exVatPrice,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }